/* Arjit4Amply: Product gallery interaction, ported from the handover package's
   Handover_Package/reference-site/product-gallery.js. Bidirectional loop (Previous
   from slide 1 wraps to slide 8 and back), swipe + keyboard nav, thumbnail
   auto-scroll, and the mini-canvas thumbnail scaling for the non-photo slides
   (benefit slide, review cards, supplement facts) - all slides are pre-rendered by
   Liquid in both places (full slide + thumbnail), so this only toggles visibility
   and computes the scale/fit-height values the reference computed via its own
   version of this same logic. */
(function () {
  document.querySelectorAll('.matre-product-gallery').forEach(initGallery);

  function initGallery(root) {
    var frame = root.querySelector('.matre-gallery-frame');
    var stage = root.querySelector('.matre-gallery-stage');
    var thumbs = root.querySelector('.matre-gallery-thumbs');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.matre-gallery-slide'));
    var buttons = Array.prototype.slice.call(thumbs.querySelectorAll('button[data-thumb]'));
    var navButtons = root.querySelectorAll('[data-slide-direction]');
    var selected = 0;

    stage.tabIndex = 0;
    stage.setAttribute('role', 'region');
    stage.setAttribute('aria-label', 'Product image carousel');

    function select(index) {
      selected = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === selected);
      });
      buttons.forEach(function (button, i) {
        button.setAttribute('aria-pressed', String(i === selected));
      });
      var button = buttons[selected];
      var left = button.offsetLeft - thumbs.offsetLeft;
      if (left < thumbs.scrollLeft || left + button.offsetWidth > thumbs.scrollLeft + thumbs.clientWidth) {
        thumbs.scrollTo({
          left: Math.max(0, left - (thumbs.clientWidth - button.offsetWidth) / 2),
          behavior: 'smooth',
        });
      }
      scheduleFit();
    }

    navButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        select(selected + Number(button.dataset.slideDirection));
      });
    });

    buttons.forEach(function (button, i) {
      button.addEventListener('click', function () {
        select(i);
      });
    });

    root.addEventListener('keydown', function (event) {
      if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) === -1) return;
      event.preventDefault();
      select(
        event.key === 'Home'
          ? 0
          : event.key === 'End'
            ? slides.length - 1
            : selected + (event.key === 'ArrowLeft' ? -1 : 1)
      );
    });

    var touchStart = null;
    stage.addEventListener(
      'touchstart',
      function (event) {
        if (event.touches.length === 1) {
          touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
        }
      },
      { passive: true }
    );
    stage.addEventListener(
      'touchend',
      function (event) {
        if (!touchStart) return;
        var dx = event.changedTouches[0].clientX - touchStart.x;
        var dy = event.changedTouches[0].clientY - touchStart.y;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) {
          select(selected + (dx < 0 ? 1 : -1));
        }
        touchStart = null;
      },
      { passive: true }
    );
    stage.addEventListener('touchcancel', function () {
      touchStart = null;
    });

    /* Force a fixed-size review card to shrink (never clip) when its own content
       would overflow the stage - revision-2 change log: "the card scales within
       the fixed gallery stage when necessary." */
    function fitContentCard(card, width, height) {
      if (!card || width <= 0 || height <= 0) return;
      card.style.width = width + 'px';
      card.style.minHeight = height + 'px';
      card.style.transform = 'translate(-50%, -50%)';
      var naturalHeight = Math.max(height, card.scrollHeight);
      var scale = Math.min(1, height / naturalHeight);
      card.style.transform = 'translate(-50%, -50%) scale(' + scale + ')';
    }

    function sizeMiniatures() {
      var rect = stage.getBoundingClientRect();
      var width = rect.width;
      var height = rect.height;
      fitContentCard(slides[selected].querySelector('.matre-review-card'), width, height);
      root.querySelectorAll('.matre-gallery-mini-viewport').forEach(function (viewport) {
        var canvas = viewport.firstElementChild;
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';
        fitContentCard(canvas.querySelector('.matre-review-card'), width, height);
        var scale = Math.min(viewport.clientWidth / width, viewport.clientHeight / height);
        canvas.style.transform = 'translate(-50%, -50%) scale(' + scale + ')';
      });
    }

    /* Fit the stage height to the visible viewport on load, like the approved
       reference (Handover_Package/reference-site/app.js fitGallery()). The
       reference always reserves room for its mobile sticky "Add to Cart" bar in
       this calculation (min 86px), even though that bar isn't built yet here
       (Checkpoint 2) - reserving the same space now keeps the gallery height a
       match today, and this becomes the real element's height once it exists. */
    function fitGallery() {
      var top = root.getBoundingClientRect().top + window.scrollY;
      var thumbSpace = thumbs.getBoundingClientRect().height + parseFloat(getComputedStyle(thumbs).marginTop || 0);
      var mobileBar = window.innerWidth <= 600 ? 86 : 0;
      root.style.setProperty('--matre-gallery-fit-height', Math.max(240, window.innerHeight - top - thumbSpace - mobileBar - 16) + 'px');
    }

    var fitFrame;
    function scheduleFit() {
      cancelAnimationFrame(fitFrame);
      fitFrame = requestAnimationFrame(function () {
        fitGallery();
        sizeMiniatures();
      });
    }

    var resizeObserver = new ResizeObserver(scheduleFit);
    resizeObserver.observe(stage);
    resizeObserver.observe(thumbs);
    window.addEventListener('resize', scheduleFit);
    if (document.fonts) document.fonts.ready.then(scheduleFit);

    select(0);
    scheduleFit();
  }
})();
